var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnterpriseAvarter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 51,
    fill: "#F5A623",
    stroke: "#F5A623",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.001 25C43.721 25 37.001 32.8425 37.001 42.5056C37.001 51.9819 43.361 59.6844 51.801 59.9645C51.921 59.9645 52.081 59.9645 52.161 59.9645C52.241 59.9645 52.361 59.9645 52.441 59.9645C52.481 59.9645 52.521 59.9645 52.521 59.9645C60.601 59.6377 66.961 51.9819 67.001 42.5056C67.001 32.8425 60.281 25 52.001 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.365 84.5584C75.1309 92.7779 64.1212 97.8399 52.0013 97.8399C39.8815 97.8399 28.8718 92.7779 20.6377 84.5584C21.7479 79.9977 24.7548 75.8378 29.1494 72.6302C41.7781 63.5087 62.3171 63.5087 74.8533 72.6302C79.2942 75.8378 82.2548 79.9977 83.365 84.5584Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseAvarter);
export default __webpack_public_path__ + "static/media/enterprise-avarter.536a2a541b9175c54035211be590cae8.svg";
export { ForwardRef as ReactComponent };